export const formatDollarPrice = (price,input=false) => {
  if (!price) return "";
// console.log(" price",typeof(price))
  // Convert to number first (this removes .00 properly)
  const number = Math.round(Number(price));

  if (isNaN(number)) return "";

// console.log(input ,number.toLocaleString("en-US") ,typeof(number.toLocaleString("en-US") ) )
  return input? number.toLocaleString("en-US")   :`$${number.toLocaleString("en-US")}`;
};


export const formatNoDollarPrice = (price,input=false) => {
  if (!price) return "";
// console.log(" price",typeof(price))
  // Convert to number first (this removes .00 properly)
  const number = Math.round(Number(price));

  if (isNaN(number)) return "";

// console.log(input ,number.toLocaleString("en-US") ,typeof(number.toLocaleString("en-US") ) )
  return Number(number.toLocaleString("en-US"))
};




export const safeToFixed = (value, digits = 2, fallback = "0") => {
  const num = Number(value);

  if (isNaN(num)) {
    return fallback;
  }

  return `$${num.toFixed(digits)}`;
};